import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var ScreenButton = function ScreenButton(_ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: twMerge("bg-primary border-0 outline-none text-white p-3 text-center rounded text-lg font-bold w-full cursor-pointer disabled:bg-neutral-60 disabled:text-neutral-70", className),
    disabled: disabled,
    onClick: onClick
  }, children);
};
export default ScreenButton;